import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import MolGrid from "../../components/Grid/MolGrid";
import { SGBSCategoryCriteriaData } from "./data/SGBSCategoryCriteriaData";
import { SGBSCategoryCriteriaConfig } from "./data/SGBSCategoryCriteriaConfig";

const SGBSCategoryList = () => {
  const navigate = useNavigate();
  const molGridRef = useRef();
  const SGBSCategoryCriteriaRef = useRef();
  const [formData, setFormData] = useState(SGBSCategoryCriteriaData);

  const companies = [
    {
      id: 1,
      category: "Architectural",
      subCategory: "Ceiling Coverings",
      type: "Acoustic Ceiling Board",
      criteriaName: "Acoustic Ceiling Board 20250604",
      certificate: "Common",
      status: "Submitted",
    },
    {
      id: 2,
      category: "Architectural",
      subCategory: "Ceiling Coverings",
      type: "Acoustic Ceiling Board",
      criteriaName: "Acoustic Ceiling Board 20250604",
      certificate: "Common",
      status: "Submitted",
    },
    {
      id: 3,
      category: "Architectural",
      subCategory: "Ceiling Coverings",
      type: "Acoustic Ceiling Board",
      criteriaName: "Acoustic Ceiling Board 20250604",
      certificate: "Common",
      status: "Submitted",
    },
    {
      id: 4,
      category: "Architectural",
      subCategory: "Ceiling Coverings",
      type: "Acoustic Ceiling Board",
      criteriaName: "Acoustic Ceiling Board 20250604",
      certificate: "Common",
      status: "Submitted",
    },
    {
      id: 5,
      category: "Architectural",
      subCategory: "Ceiling Coverings",
      type: "Acoustic Ceiling Board",
      criteriaName: "Acoustic Ceiling Board 20250604",
      certificate: "Common",
      status: "Submitted",
    },
    {
      id: 6,
      category: "Architectural",
      subCategory: "Ceiling Coverings",
      type: "Acoustic Ceiling Board",
      criteriaName: "Acoustic Ceiling Board 20250604",
      certificate: "Common",
      status: "Submitted",
    },
    {
      id: 7,
      category: "Architectural",
      subCategory: "Ceiling Coverings",
      type: "Acoustic Ceiling Board",
      criteriaName: "Acoustic Ceiling Board 20250604",
      certificate: "Common",
      status: "Submitted",
    },
    {
      id: 8,
      category: "Architectural",
      subCategory: "Ceiling Coverings",
      type: "Acoustic Ceiling Board",
      criteriaName: "Acoustic Ceiling Board 20250604",
      certificate: "Common",
      status: "Submitted",
    },
    {
      id: 9,
      category: "Architectural",
      subCategory: "Ceiling Coverings",
      type: "Acoustic Ceiling Board",
      criteriaName: "Acoustic Ceiling Board 20250604",
      certificate: "Common",
      status: "Submitted",
    },
  ];

  // const handleViewClick = (data) => {
  //   console.log(data);
  //   let url =
  //     data.isProduct == true
  //       ? `/addRequirement/${encryptAESID(data?.id)}`
  //       : `/addRequirement/${encryptAESID(data?.id)}`;
  //   navigate(url);
  // };

  const actionHandler = {
    // Edit: handleViewClick,
  };

  return (
    <div className="crud-requirement-list">
      <div className="corporate-member-list">
        <div className="sgbp-category">
          <div className="row status-input pr-0">
            <FormCreator ref={SGBSCategoryCriteriaRef} {...formData} />
          </div>
          <div className="sgbp-category-filter">
            <Buttons
              buttonText="Search"
              buttonTypeClassName="search-btn"
              // onClick={handleSearch}
            />
            <Buttons
              buttonText="Clear"
              buttonTypeClassName="btn btn-secondary mb-2"
              // onClick={handleClearClick}
            />
          </div>
          <div className="add-btn-sec mt-4 pr-0">
            <Buttons
              buttonText="+ Add New"
              buttonTypeClassName="add-btn"
              // onClick={handleAddRow}
            />
          </div>
        </div>

        <div className="member-list">
          <MolGrid
            ref={molGridRef}
            configuration={SGBSCategoryCriteriaConfig}
            dataSource={companies}
            // allowPagination={true}
            // pagination={paginationRequest}
            // onPageChange={handlePageChange}
            onActionChange={actionHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default SGBSCategoryList;
